module.exports = __webpack_public_path__ + "static/media/GoodbyeFrenchFry.f711b505.jpg";